import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_operator')({
  component: OperatorLayout,
});

function OperatorLayout() {
  return (
    <div className="px-10 pt-2xl pb-3xl flex-1 flex flex-col overflow-scroll">
      <Outlet />
    </div>
  );
}
